import { TripStepTypes } from '../../lib/types/models/trip-booking/trip-step'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createTripStep(input: TripStepTypes.Request & { tripBookingId: number }) {
  const { tripBookingId, ...data } = input
  return restApiClient
    .url(constructApiUrl(API['trip-bookings'].createTripStep.url, { id: tripBookingId }))
    .post<TripStepTypes.Full, TripStepTypes.Request>(data)
}
